import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { Field } from '../field'
import { Box, InfoBox } from '../../atoms/box'
import { Button } from '../../atoms/button'
import { Flex } from '../../atoms/flex'
import { FormatAmount } from '../../atoms/formatAmount'
import { If } from '../../atoms/if'
import { Image } from '../../atoms/image'
import { toast } from '../../atoms/toast'
import { Text, Title } from '../../atoms/text'
import { useTranslation } from '../../../context/translationProvider'
import storageService from '../../../services/storageService'
import { useMenuApiData } from '../../../hooks/graphqlStaticQuery/useMenuApiData'
import InformationIcon from '../../../images/icon_information.svg'
import { ImageContainer, Wrapper } from './styles'
import { useEventTracking } from '../../../context/eventTrackingProvider'

const QRModal = ({ data }) => {
  const { translate } = useTranslation()
  const { qrCodeImage, qrCodeText, id } = data
  const user = storageService.getUser()
  const menuData = useMenuApiData()
  const { trackEvent, EVENT_NAMES, EVENT_LOCATIONS } = useEventTracking()

  useEffect(() => {
    trackEvent(EVENT_NAMES.SCREEN_LOADED,
      { screen_name: EVENT_LOCATIONS.PIX }
    )
  }, [])

  const copy = () => {
    try {
      navigator.clipboard.writeText(qrCodeText)
      toast.success(translate('common.copied'))
    } catch (err) {
      toast.error(translate('common.browserFailure'))
    }
  }

  return (
    <Wrapper>
      <Flex
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        style={{ marginBottom: '1rem' }}
      >
        <Flex>
          <img
            src={menuData?.logo?.image?.url}
            alt="logo"
            className="kto-logo"
            loading="lazy"
          />
        </Flex>
        <Text
          style={{
            marginBottom: '0',
            textAlign: 'right',
          }}
        >
          {translate('payments.deposit.transactionID')} &#x23;{id}
        </Text>
      </Flex>

      <Box marginBottom="1rem">
        <Text style={{ marginBottom: '0.6rem', textAlign: 'center' }}>
          {translate('payments.deposit.transferExactAmount')}&nbsp;
        </Text>
        <Title
          level={1}
          style={{ marginBottom: '0.5em', textAlign: 'center' }}
          id="depositModalValue"
        >
          <FormatAmount
            amount={data?.amount}
            shortCode={user.wallet.currency.short_code}
            maximumFractionDigits="2"
            minimumFractionDigits="2"
            useGrouping={data?.amount.toString().length >= 5}
            currencySymbol={user?.wallet?.currency?.symbol}
          />
        </Title>
      </Box>

      <InfoBox
        style={{ display: 'flex', marginBottom: '2em' }}
        theme={'outlined'}
        id="alertDepositModal"
      >
        <img style={{ marginRight: '1em' }} src={InformationIcon} />
        <Text>
          {translate('payments.deposit.paymentInstructionsInovapayDirectPix')}
        </Text>
      </InfoBox>
      <Box marginBottom="1rem">
        <Title level={3} style={{ marginBottom: '0.5em' }}>
          {translate('payments.deposit.copyLink')}
        </Title>
        <Flex gap="0.5em" alignItems="flex-end" justifyContent="center">
          <Box width="60%">
            <Field
              id="referral-link"
              disabled
              forceValue={qrCodeText}
              noBottomMargin
            />
          </Box>
          <Box width="40%">
            <Button size="small" onClick={copy} id="btnCopyDepositModal">
              {translate('common.copy')}
            </Button>
          </Box>
        </Flex>
      </Box>

      <Box style={{ position: 'relative' }}>
        <If
          condition={translate('payments.deposit.scanQR')}
          render={() => (
            <Text
              small="yes"
              style={{ textAlign: 'center', position: 'relative', zIndex: '1' }}
            >
              {translate('payments.deposit.scanQR')}
            </Text>
          )}
        />

        <ImageContainer>
          <Image url={qrCodeImage} width="60%" />
        </ImageContainer>
      </Box>
    </Wrapper>
  )
}

QRModal.propTypes = {
  data: PropTypes.object,
  qrCodeImage: PropTypes.string,
  qrCodeText: PropTypes.string,
  amount: PropTypes.string,
  id: PropTypes.string,
}

export default QRModal
